import FalsePositiveInfoTable from './FalsePositiveInfoTable';

export default FalsePositiveInfoTable;


// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/false-positive-Info-table/index.js